//import { height, width } from "@mui/system";

const Stack = () => {
  
  return (
    <>
     
      <h2 className="title-font pink-text h2-tag">Skills</h2>

      <ol className="stack-section ">
        <li>HTML5</li>
        <li>CSS3</li>
        <li>JavaScript ES6+</li>
        <li>React.js</li>
        <li>Node.js</li>
        <li>Express</li>
        <li>Heroku</li>
        <li>Git</li>
        <li>Postman</li>
        <li>Visual Studio Code</li>
        <li>Bootstrap</li>
        <li>Chart.js</li>
        <li>Mongodb</li>
        <li>MySQL</li>
        <li>AWS</li>
        <li>Netlify</li>
      </ol>
    </>
  );
};
export default Stack;
